import request from '@/config/axios'

export interface O2oTrustConfigVO {
  id?: number
  tip?: string
  csMobile?: string
  status?: number
}

export interface O2oTrustItemVO {
  id?: number
  label?: string
  iconUrl?: string
  sort?: number
  status?: number
  createTime?: Date
}

export const O2oTrustApi = {
  getConfig: async () => {
    return await request.get({ url: '/o2o/marketing/trust/config/get' })
  },
  saveConfig: async (data: O2oTrustConfigVO) => {
    return await request.put({ url: '/o2o/marketing/trust/config/save', data })
  },
  getItemPage: async (params: any) => {
    return await request.get({ url: '/o2o/marketing/trust/item/page', params })
  },
  getItem: async (id: number) => {
    return await request.get({ url: '/o2o/marketing/trust/item/get?id=' + id })
  },
  createItem: async (data: O2oTrustItemVO) => {
    return await request.post({ url: '/o2o/marketing/trust/item/create', data })
  },
  updateItem: async (data: O2oTrustItemVO) => {
    return await request.put({ url: '/o2o/marketing/trust/item/update', data })
  },
  deleteItem: async (id: number) => {
    return await request.delete({ url: '/o2o/marketing/trust/item/delete?id=' + id })
  },
  listEnabledItems: async () => {
    return await request.get({ url: '/o2o/marketing/trust/item/list-enabled' })
  }
}
